import { cn } from "@/lib/utils";
import type { BrandBarometerLabel } from "@/lib/api";

const LABEL_PL: Record<BrandBarometerLabel, string> = {
  spokoj: "Spokój",
  napiecie: "Napięcie",
  alarm: "Alarm",
  malo_danych: "Mało danych",
};

function labelColor(label: BrandBarometerLabel): string {
  if (label === "spokoj") return "text-emerald-600";
  if (label === "napiecie") return "text-amber-600";
  if (label === "alarm") return "text-rose-600";
  return "text-muted-foreground";
}

function arcColor(label: BrandBarometerLabel): string {
  if (label === "spokoj") return "#059669";
  if (label === "napiecie") return "#d97706";
  if (label === "alarm") return "#e11d48";
  return "#94a3b8";
}

export default function BrandGauge({
  value,
  label,
  className,
}: {
  value: number | null;
  label: BrandBarometerLabel;
  className?: string;
}) {
  const pct = value == null ? 0 : Math.max(0, Math.min(100, value));
  const r = 54;
  const c = 2 * Math.PI * r;
  const dash = (pct / 100) * c;

  return (
    <div className={cn("flex flex-col items-center justify-center", className)}>
      <div className="relative h-36 w-36">
        <svg viewBox="0 0 140 140" className="h-full w-full -rotate-90">
          <circle
            cx="70"
            cy="70"
            r={r}
            fill="none"
            stroke="currentColor"
            strokeWidth="12"
            className="text-slate-100"
          />
          <circle
            cx="70"
            cy="70"
            r={r}
            fill="none"
            stroke={arcColor(label)}
            strokeWidth="12"
            strokeLinecap="round"
            strokeDasharray={`${dash} ${c - dash}`}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="text-3xl font-bold tabular-nums tracking-tight">
            {value == null ? "n/d" : Math.round(value)}
          </span>
          <span className={cn("text-xs font-semibold uppercase tracking-wide", labelColor(label))}>
            {LABEL_PL[label]}
          </span>
        </div>
      </div>
      <p className="mt-2 max-w-[14rem] text-center text-xs text-muted-foreground">
        Score 0–100 z tonu komentarzy, buffera, odpowiedziów i CTA
      </p>
    </div>
  );
}

export function componentLabel(key: string): string {
  if (key === "tone") return "Ton";
  if (key === "buffer") return "Buffer";
  if (key === "coverage") return "Odpowiedzi";
  if (key === "commerce") return "CTA";
  return key;
}

export function scoreLabelPl(label: BrandBarometerLabel): string {
  return LABEL_PL[label];
}
